import { useEffect, useState } from "react";
import ApiService from "../../services/apiService";
import Loader from "../../elements/Loader";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

export default function PromoCodeList() {
    const [promoCodes, setPromoCodes] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchPromoCodes();
    }, []);

    const fetchPromoCodes = async () => {
        setLoading(true);
        ApiService.get("promotion/promocodes")
            .then((response) => {
                setLoading(false);
                setPromoCodes(response.data);
            })
            .catch((err) => {
                setLoading(false);
                toast.error("Failed to fetch promo codes");
            });
    };

    return (
        <div className="row">
            <div className="col-xl-12">
                {loading && <Loader />}
                <div className="card dz-card" id="bootstrap-table2">
                    <div className="card-header flex-wrap d-flex justify-content-between border-0">
                        <div>
                            <h4 className="card-title">Promo Code List</h4>
                        </div>
                        <ul className="nav nav-tabs dzm-tabs">
                            <li className="nav-item" role="presentation">
                                <Link to="/add-promocode" className="btn btn-primary">
                                    Add Promo Code
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table table-responsive-md">
                                <thead>
                                    <tr>
                                        <th><strong>Sr No.</strong></th>
                                        <th><strong>Name</strong></th>
                                        <th><strong>Code</strong></th>
                                        <th><strong>Description</strong></th>
                                        <th><strong>Discount Value</strong></th>
                                        <th><strong>Discount Type</strong></th>
                                        <th><strong>Used Count</strong></th>
                                        <th><strong>Start Date</strong></th>
                                        <th><strong>End Date</strong></th>
                                        <th><strong>Status</strong></th>
                                        <th><strong>Action</strong></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {promoCodes && promoCodes.length > 0 && promoCodes.map((promo, index) => (
                                        <tr key={promo.id}>
                                            <td><strong>{index + 1}</strong></td>
                                            <td>{promo.name}</td>
                                            <td>{promo.code}</td>
                                            <td>{promo.description}</td>
                                            <td>{promo.discount_worth}</td>
                                            <td>{promo.discountType}</td>
                                            <td>{promo.used_count}</td>
                                            <td>{new Date(promo.start_date).toLocaleDateString()}</td>
                                            <td>{new Date(promo.end_date).toLocaleDateString()}</td>
                                            <td>{promo.status}</td>
                                            <td>
                                                <Link
                                                    to={`/edit-promocode/${promo.id}`}
                                                    className="btn btn-primary shadow btn-xs sharp me-1"
                                                >
                                                    <i className="fa fa-pencil" />
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}